import Immutable from 'immutable';
import {
  CLEAR_BAGGAGE_DISCOUNT_CODES,
  CLEAR_SPECIAL_BAGGAGE_DISCOUNT_CODES,
  FLAG_GETTING_BAGGAGE_DISCOUNT_CODES,
  FLAG_GETTING_SPECIAL_BAGGAGE_DISCOUNT_CODES,
  GET_BAGGAGE_DISCOUNT_CODES,
  GET_SPECIAL_BAGGAGE_DISCOUNT_CODES,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  regular: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  special: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BAGGAGE_DISCOUNT_CODES:
      return state.setIn(['regular', 'loading'], payload);
    case GET_BAGGAGE_DISCOUNT_CODES:
      return state.setIn(['regular', 'content'], Immutable.Map(payload));
    case CLEAR_BAGGAGE_DISCOUNT_CODES:
      return state.setIn(
        ['regular', 'content'],
        INITIAL_STATE.getIn(['regular', 'content']),
      );
    case FLAG_GETTING_SPECIAL_BAGGAGE_DISCOUNT_CODES:
      return state.setIn(['special', 'loading'], payload);
    case GET_SPECIAL_BAGGAGE_DISCOUNT_CODES:
      return state.setIn(['special', 'content'], Immutable.Map(payload));
    case CLEAR_SPECIAL_BAGGAGE_DISCOUNT_CODES:
      return state.setIn(
        ['special', 'content'],
        INITIAL_STATE.getIn(['special', 'content']),
      );
    default:
      return state;
  }
};
